import { Switch, useRouteMatch } from 'react-router-dom';

import AuthenticatedPrivateRoute from '../../../AuthenticatedPrivateRoute';
import ApplicationGroupDetail from './ApplicationGroupDetail';
import ApplicationGrouping from './ApplicationGrouping';


function ApplicationGroupingPages() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <AuthenticatedPrivateRoute path={`${path}/:groupId`} component={ApplicationGroupDetail}/>
            <AuthenticatedPrivateRoute path={`${path}`} component={ApplicationGrouping}/>
        </Switch>
    );
}

export default ApplicationGroupingPages;
